import { defineAction } from '~/prix'
import migrationMigrateOltpAction from './migrationMigrateOltp.action.json' with { type: 'json' }
import { z } from 'zod'
import { enumerated } from '~/prix/types/enumerated'

const migrationMigrateOltpDefinition = defineAction({
  ...migrationMigrateOltpAction,
  input: z.object({}),
  output: z.object({
    results: z.array(
      z.object({
        timestamp: z.number(),
        result: enumerated({ success: 'Sucesso', skip: 'Já executada' }),
      }),
    ),
  }),
})

export default migrationMigrateOltpDefinition
